import { render, staticRenderFns } from "./CaseSoldOut.vue?vue&type=template&id=43345622&"
import script from "./CaseSoldOut.vue?vue&type=script&lang=js&"
export * from "./CaseSoldOut.vue?vue&type=script&lang=js&"
import style0 from "./CaseSoldOut.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports